import { AlmeColorProp } from "../../models/AlmeColorMapping";

export interface UtilityBarLink {
    href: string;
    label: string;
    target: "_self" | "_blank" | "_parent" | "_top";
}

export interface UtilityBarItem {
    title?: string;
    links: UtilityBarLink[];
}

export interface AlmeUtilityBarConfig {
    utilityBar: {
        isEnabled: boolean;
        items: UtilityBarItem[];
        breakpoint: number;
        styles: {
            backgroundColor?: AlmeColorProp;
            borderColor?: AlmeColorProp;
        };
    };
}

/**
 * This is the baseline utility bar config.
 * @summary
 * ! Important do not edit this config with client customizations!
 * Custom client config changes should be made in src/personas/config/appConfigMain
 * @see appConfigMain
 */
const defaultConfig: AlmeUtilityBarConfig = {
    utilityBar: {
        isEnabled: false,
        breakpoint: 945,
        styles: {
            backgroundColor: 'default',
            borderColor: 'secondary',
        }, items: [
            {
                title: 'Medication Guide ISI menu', links: [{
                    href: "#test",
                    label: "Important Safety\n    Information",
                    target: "_self",
                },
                {
                    href: "https://www.xkcd.com",
                    label: "xkcd.com",
                    target: "_blank",
                },
                {
                    href: "https://www.google.com",
                    label: "Prescribing\n Information",
                    target: "_blank",
                }],
            },
            {
                links: [
                {
                    href: "https://www.google.com",
                    label: "Prescribing\n Information",
                    target: "_blank",
                }],
            },
            {
                 links: [{
                    href: "https://www.xkcd.com",
                    label: "Medication\n Guide",
                    target: "_blank",
                }],
            },
        ],
    },
};

export default defaultConfig;
